import { Cart } from "../cart/CartTypes";
import Tools from "@root/ts/Tools";
import ApiProxy from "../../ts/ApiProxy";
import { Emitter } from "strict-event-emitter";
import Utility from "../../ts/sframe/Utility";
import GS from "../../ts/GlobalSetting";

const MY_COOKIE_NAME: string = "ez_cart_data";
let _cartCookieObj: any;

export default class CartCookie {
  static emitter: Emitter<{ countChange: [newCount: number] }>

  private static _getCookieObject() {
    let commonPageData = ApiProxy.getCommonPageData();
    if (commonPageData.login_state.is_login) {
      let cookieName = MY_COOKIE_NAME + "-" + commonPageData.login_state.info.id;
      return Tools.getLocalStorageObj(cookieName)
    } else {
      console.error(`非登入狀態應該不會存取購物車 cookie`);
      return {};
    }
  }

  private static _resetCookie() {
    console.log("reset cart cookie");
    let commonPageData = ApiProxy.getCommonPageData();
    let cookieName = MY_COOKIE_NAME + "-" + commonPageData.login_state.info.id;
    localStorage.removeItem(cookieName);
  }

  private static _getCoolieName() {
    let commonPageData = ApiProxy.getCommonPageData();
    if (commonPageData.login_state.is_login)
      return MY_COOKIE_NAME + "-" + commonPageData.login_state.info.id;
    else
      return null;
  }

  static init(itemList?: Cart.CartRecord[]) {
    if (!Tools.isLocalStorageAvailable())
      return;
    if (GS.setting.testEnv && Utility.urlParams.reset_cart_cookie === "1")
      this._resetCookie();
    let obj = this._getCookieObject();

    if (!itemList)
      _cartCookieObj = obj;
    else
      this._applyData(obj, itemList, false);

    Tools.saveLocalStorageObj(this._getCoolieName(), _cartCookieObj);
    this.emitter.emit("countChange", this.getNumCartItems());
  }

  private static _applyData(obj: any, itemList: Cart.CartRecord[], applyCookieCountToData: boolean = false) {
    _cartCookieObj = {};

    itemList.forEach((cartData) => {
      _cartCookieObj[cartData.id] = {};
      cartData.plan_data.unit_data.forEach((unitData) => {
        if (applyCookieCountToData && obj[cartData.id] && obj[cartData.id][unitData.id]) {
          let count = obj[cartData.id][unitData.id];
          _cartCookieObj[cartData.id][unitData.id] = unitData.count = Tools.parseInt(count);
        } else {
          _cartCookieObj[cartData.id][unitData.id] = unitData.count;
        }
      });
    });
  }

  static getCartData(cartId: string) {
    return _cartCookieObj[cartId];
  }

  static getNumCartItems() {
    let obj = this._getCookieObject();
    let num = 0;
    for (let key in obj) {
      num++;
    }
    return num;
  }

  static addOrUpdate(cartData: Cart.CartRecord) {
    _cartCookieObj[cartData.id] = {};
    cartData.plan_data.unit_data.forEach((unitData) => {
      _cartCookieObj[cartData.id][unitData.id] = unitData.count;
    });
    Tools.saveLocalStorageObj(this._getCoolieName(), _cartCookieObj);
    this.emitter.emit("countChange", this.getNumCartItems());
  }

  static delete(cartId: string) {
    delete _cartCookieObj[cartId];
    Tools.saveLocalStorageObj(this._getCoolieName(), _cartCookieObj);
    this.emitter.emit("countChange", this.getNumCartItems());
  }
}

CartCookie.emitter = new Emitter();